const ru = {
  "lang.label": "Язык",
  "nav.main": "Главная",
  "nav.go": "Игра",
  "nav.players": "Игроки",
  "nav.login": "Войти",
  "nav.menu": "Меню",
  "nav.navigation": "Навигация",
  "nav.welcome": "Здравствуйте, {name}!",
  "nav.profile": "Профиль",
  "nav.logout": "Выйти",
  "nav.status": "Статус",
  "nav.verified": "Подтверждён",
  "nav.pending": "Ожидает",
  "country.prompt": "Выберите страну, чтобы продолжить",
  "country.kz": "Казахстан",
  "country.ru": "Россия",
  "login.title": "Вход",
  "login.haveAccount": "Уже есть аккаунт?",
  "login.signIn": "Войти",
  "login.noAccount": "Нет аккаунта?",
  "login.signUp": "Регистрация",
  "login.email": "Электронная почта",
  "login.password": "Пароль",
  "login.submit": "Войти",
  "login.err.emailRequired": "Электронная почта обязательна для заполнения",
  "login.err.email": "Email введен некорректно",
  "login.err.emailMax": "Email слишком длинный",
  "login.err.passwordRequired": "Пароль обязателен для заполнения",
  "login.err.capital": "Пароль должен содержать хотя бы одну заглавную букву",
  "login.err.digit": "Пароль должен содержать хотя бы одно число",
  "login.err.passwordMin": "Пароль должен состоять минимум из 8 символов",
  "login.err.passwordMax": "Пароль до 25 знаков",
  "login.err.captcha": "Пройди капчу",
  "auth.invalid": "Email или пароль введены некорректно",
  "auth.emailExist": "Пользователь с таким Email уже существует",
  "auth.notFound": "Пользователь не найден",
  "auth.tooMany": "Слишком много попыток входа. Попробуйте позже",
  "register.title": "Регистрация",
  "register.email": "Электронная почта",
  "register.password": "Пароль",
  "register.nickname": "Никнейм",
  "register.birth": "Дата рождения",
  "register.phone": "Номер телефона",
  "register.specialty": "Выбери свою специальность",
  "register.town": "Выбери город",
  "register.sex": "Выберите ваш пол",
  "register.male": "Мужской",
  "register.female": "Женский",
  "register.choose": "Выбрать...",
  "register.showAgreement": "Ознакомиться с соглашением",
  "register.hideAgreement": "Скрыть",
  "register.agreementTitle": "Соглашение",
  "register.agreementIntro":
    "Для использования приложения, поставив галочку, вы даёте согласие и подтверждаете:",
  "register.agree": "Подтвердить соглашение",
  "register.submit": "Зарегистрироваться",
  "register.submitting": "Регистрация...",
  "register.levelWait":
    "Уровень игрока ещё не загружен. Подождите и попробуйте снова.",
  "register.fail": "Не удалось зарегистрироваться",
  "register.a1": "Даёте разрешение на сбор и обработку данных.",
  "register.a2":
    "Вы совершеннолетний, либо в вашей команде состоят ваши родители.",
  "register.a3":
    "Ваше здоровье позволяет заниматься спортом и переносить нагрузки игры.",
  "register.a4":
    "При неправомерных действиях игрока информация может быть передана органам порядка.",
  "register.a5": "В видеороликах запрещены мат и нецензурная лексика.",
  "register.a6":
    "В видеороликах запрещена реклама, если она не является частью задания.",
  "register.a7":
    "Загрузка посторонних видео вместо нужных ведёт к блокировке аккаунта.",
  "register.a8":
    "В команде с подростками младше 16 лет должны быть двое взрослых, один из них — родитель подростка.",
  "register.a9": "У вас нет противопоказаний к спортивным нагрузкам.",
  "register.a10":
    "Права на видеоролики, загруженные в приложение, принадлежат администрации игры.",
  "register.a11":
    "Публикация роликов разрешена только со ссылкой на игру.",
  "register.a12":
    "Каждый участник отвечает за себя и за ребёнка, если в команде есть подростки от 16 лет.",
  "register.a13":
    "Администрация может удалить команду и участников при нарушении правил без объяснения причин.",
  "register.a14":
    "Администрация может ограничить соцсети, которые используют контент вопреки правилам.",
  "register.a15":
    "Указанные контакты достоверны и принадлежат вам.",
  "register.a16":
    "Участники используют надёжные пароли со знаками, буквами и цифрами.",
  "register.a17":
    "Администрация может запросить дополнительные данные при сомнениях в родительских правах.",
  "register.a18":
    "Для заданий нужно много ходить и решать нестандартные задачи на камеру.",
  "register.a19":
    "Приветственный ролик команды должен быть с лицами участников.",
  "register.a20":
    "При несоответствии данных игрока и видео администрация может принять меры к команде.",
  "register.err.nickRequired": "Nickname обязателен для заполнения",
  "register.err.nickChars": "Содержит только буквы и цифры",
  "register.err.nickMin": "Nickname должен состоять минимум из 3 символов",
  "register.err.nickMax": "До 15 знаков",
  "register.err.birth": "Не указана дата рождения",
  "register.err.phoneRequired": "Номер телефона обязателен для заполнения",
  "register.err.phoneMin": "Номер телефона должен содержать минимум 10 цифр",
  "register.err.phoneMax": "Номер телефона должен содержать максимум 15 цифр",
  "register.err.specialty": "Обязательно выберите вашу специальность",
  "register.err.license":
    "Вы не можете использовать сервис без подтверждения соглашения",
  "register.err.town": "Не выбран город",
  "main.teamName": "Название подразделения {name}",
  "main.createAndGo": "Создай команду и вперёд",
  "main.waitMembers": "Жди подтверждения участников твоей группы",
  "main.createTeam": "Создать команду",
  "main.addTeam": "Вступить в команду",
  "main.dating": "Знакомства",
  "main.verify": "Подтвердить почту",
  "footer.rights": "Все права защищены.",
  "footer.contact": "Контакты",
  "common.close": "Закрыть",
  "common.loading": "Загрузка...",
  "common.loadingTeam": "Загрузка команды...",
  "common.city": "Город:",
  "common.back": "Назад",
  "common.send": "Отправить",
  "common.confirm": "Подтвердить",
  "common.cancel": "Отмена",
  "team.title": "Создать команду",
  "team.invited": "У вас есть приглашение",
  "team.tryLater": "Рекомендуем попробовать позже",
  "team.info":
    "Команда включает 3 человека. Будьте внимательны при заполнении полей. Пригласите друзей по INB (указан в профиле).",
  "team.infoLabel": "Информация:",
  "team.name": "Название команды:",
  "team.namePh": "Введите название группы",
  "team.member1": "Первый участник:",
  "team.member2": "Второй участник:",
  "team.inbPh": "INB приглашённого",
  "team.invite": "Пригласить участников",
  "team.sent": "Отправлено...",
  "team.inbHint": "Убедитесь, что INB друзей указан правильно",
  "team.already": "{name} уже в команде!",
  "team.cannot": "Вы не можете создать новую команду, пока состоите в текущей",
  "team.fail": "Не удалось создать команду. Попробуйте ещё раз.",
  "team.err.nameRequired": "Название обязательно для заполнения",
  "team.err.letters": "Название может содержать только буквы",
  "team.err.length": "От 3 до 32 символов",
  "team.err.exists": "Название группы существует",
  "team.err.tooLong": "Имя слишком длинное",
  "team.err.inbRequired": "Введите INB напарника",
  "team.err.noUser": "Пользователь не существует",
  "team.err.inGroup": "Пользователь состоит в группе",
  "team.err.invited": "Пользователь уже приглашён",
  "team.err.self": "Приглашаете себя",
  "team.err.repeat": "Приглашение повторяется",
  "team.err.inbMax": "INB не более 25 символов",
  "team.err.town": "Не выбран город",
  "random.info":
    "Команда до 3 человек. Галочка «Знакомство» собирает пару противоположного пола. Если пары нет, команда будет из трёх случайных людей.",
  "random.love": "Знакомство",
  "random.members": "Команда состоит из {count} участников",
  "random.two": "двух",
  "random.three": "трёх",
  "random.age": "Возраст оппонентов",
  "random.agePh": "Выберите возраст...",
  "random.place": "Место встречи",
  "random.placePh": "Выберите место...",
  "random.time": "Время встречи:",
  "random.identify": "Как узнать друг друга",
  "random.identifyPh": "Как узнать друг друга?",
  "random.create": "Создать команду",
  "random.sent": "Отправлено...",
  "random.hint": "Все поля обязательны для заполнения",
  "random.noPlaces": "Места встреч не указаны",
  "random.tryLater": "Пожалуйста, попробуйте позже",
  "random.inTeam": "{name} состоит в команде",
  "random.age1": "от 18 до 25 лет",
  "random.age2": "от 26 до 35 лет",
  "random.age3": "от 36 до 45 лет",
  "random.age4": "от 46 до 60 лет",
  "random.err.cafe": "Выбери место встречи",
  "random.err.time": "Выбери время встречи",
  "random.err.identify": "Необходимо указать",
  "random.err.identifyMax": "Текст слишком длинный",
  "random.err.age": "Выберите возраст оппонентов",
  "pay.title": "Окно оплаты",
  "pay.text":
    "Нажмите «Отправить оплату», чтобы активировать игру. Платить не нужно. Если откроется окно оплаты, не платите и напишите в поддержку.",
  "pay.paid": "Оплачено:",
  "pay.sum": "Сумма к оплате",
  "pay.send": "Отправить оплату",
  "pay.sending": "Отправка...",
  "pay.fail": "Не удалось активировать игру. Попробуйте ещё раз.",
  "pay.noTeam": "Команда не найдена. Создайте команду перед активацией игры.",
  "pay.started": "Игра уже активирована.",
  "add.title": "Приглашение в команду",
  "add.text": "Если согласны, нажмите «Принять», иначе «Отклонить».",
  "add.accept": "Принять",
  "add.reject": "Отклонить",
  "add.none": "У вас нет приглашений",
  "add.inGroup": "Вы состоите в группе",
  "add.from": "Приглашение в команду от",
  "meet.title": "Место встречи",
  "meet.cafe": "Кафе:",
  "meet.address": "Адрес:",
  "meet.datetime": "Дата и время:",
  "meet.sign": "Опознавательный знак:",
  "meet.couple": "В игре парень и девушка",
  "meet.three": "В игре 3 человека",
  "meet.button": "Мы встретились",
  "meet.time": "время",
  "verify.prompt": "Введите код, отправленный на почту",
  "verify.button": "Подтвердить почту",
  "user.teamName": "Название команды:",
  "user.loading": "Загрузка...",
  "user.noTeam": "Не состоит в команде",
  "user.city": "Город",
  "user.manage": "Управление группой",
  "user.delete": "Удалить группу",
  "user.incomplete": "Группа не полная",
  "user.waitOrDelete": "Можете удалить или дождаться подтверждения",
  "user.disband": "Расформировать",
  "user.changeCity": "Поменять город",
  "user.change": "Изменить",
  "user.specialty": "Специализация",
  "user.level": "Уровень",
  "user.skills": "Навыки:",
  "user.team": "Команда:",
  "user.notFound": "Пользователи не найдены",
  "user.search": "Попробуйте изменить параметры поиска",
  "user.name": "Имя",
  "user.skillsCol": "Навыки",
  "user.levelCol": "Уровень",
  "user.teamCol": "Команда",
  "skills.title": "Навыки:",
  "skills.empty": "Хотелось бы увидеть ваши способности",
  "go.timeUp": "Время вышло",
  "go.anyOrder": "Выполняй задания в любом порядке",
  "go.result": "Результат",
  "go.hints": "Подсказки:",
  "go.h1": "Если задание завело в тупик, позови напарника",
  "go.h2": "Задание может быть на любом языке мира",
  "go.h3": "Задание может предполагать переноску тяжёлых грузов",
  "go.h4":
    "На любое действие нужно видео, включая окончание задания",
  "go.h5":
    "На контакт-точке снимите обзор места, получите задание и запишите его выполнение",
  "go.h6":
    "Ролики игры принадлежат GO. Публикация в соцсетях и на YouTube только со ссылкой на сайт, иначе аккаунт могут заблокировать",
  "go.h7":
    "В игре оцениваются способности и достижения, которые видны на видео",
  "go.h8": "Снимай процесс игры и получай удовольствие",
  "go.h9": "Внимательно читайте задания",
  "go.h10":
    "Лучший контент опубликуют на YouTube-канале игры. Главное — адреналин и улыбка",
  "job.notInGame": "Твоя команда не в игре",
  "job.onlyAtPoint": "Задание можно увидеть только в заданной точке",
  "job.l1":
    "Снимай выполнение задания на камеру. Файл не больше 36 МБ, можно загрузить до трёх. Достаточно одного видео.",
  "job.l2": "Внимательно читай задание — это поможет победить.",
  "job.l3":
    "Следи за видеообзором. Неправильно снятое видео может повлиять на результат.",
  "job.l4": "Используй все возможные варианты решения.",
  "job.l5": "Наслаждайся игрой.",
  "job.l6": "Видео оценивают по многим параметрам.",
  "job.l7":
    "Используй возможности организма, чтобы решать задачи и достигать целей.",
  "job.locationError": "Местоположение ошибочное",
  "job.upload": "Загрузить видео",
  "job.checkLocation": "Проверьте местоположение и нажмите кнопку снова",
  "job.retry": "Повторить",
  "job.return": "Вернуться",
  "job.title": "Задание",
  "job.task": "Задача",
  "complete.notDone": "Задание не завершено: загрузите видео и завершите его",
  "complete.left": "До завершения задания",
  "complete.hours": "часов",
  "invite.none": "Нет приглашений",
  "confirm.title": "Подтверждение",
  "confirm.text": "Вы уверены, что хотите продолжить?",
  "play.inProgress": "в процессе",
  "play.win": "победа",
  "play.lose": "поражение",
  "play.missions": "Миссии",
  "play.secret": "Секрет",
  "play.results": "Результат",
  "loader.users": "Загрузка игроков...",
  "loader.missions": "Загрузка миссий...",
  "loader.notPlayed": "Вы ещё не играли",
  "loader.wait": "Ожидайте ответа...",
  "captcha.verify": "Проверить капчу",
  "location.unsupported": "Браузер не поддерживает геолокацию",
  "location.disabled": "Геолокация выключена",
  "location.lat": "широта",
  "location.lng": "долгота",
  "location.getting": "Получаем координаты…",
  "location.required": "Обязательно для заполнения",
  "location.invalid": "Данные введены некорректно",
  "location.min": "Минимум 9 символов",
  "location.max": "Максимум 12 символов",
  "location.getTask": "Получить задание",
  "go.hello": "Привет, друг...",
  "go.cityBounds": "Задание выполняется в пределах выбранного города.",
  "go.windows":
    "Перед вами окна, за которыми скрыты миссии. Нажав на любое окно, вы начинаете задание. На каждое задание даётся 24 часа. После него начинается следующее.",
  "go.missionLeft": "До завершения миссии",
  "form.uploadLabel": "Загрузите видео (.mkv, .mov, .mp4, .avi)",
  "form.upload": "Загрузить",
  "form.checkQuality":
    "Проверьте качество файла и загрузите его. Эти файлы подтверждают выполнение задания. Удачи в игре.",
  "form.reminder":
    "Каждое выполненное задание — это видеоответ. Когда все файлы загружены, нажмите «Выполнено».",
  "form.done": "Выполнено",
  "form.lowercase": "Название файла должно быть в нижнем регистре",
  "form.uploaded": "Файл загружен: {name}",
  "task.info": "Общая информация",
  "task.infoText":
    "Если это первое задание миссии, снимите обзор команды: назовите подразделение и имена или никнеймы. Записывайте действия: место контакт-точки, выполнение задания и другие подтверждения. Не больше трёх файлов. После задания переходите к следующему. Неудачное задание тоже оценивается — загрузите лучший ролик. За контент не по игре команду могут удалить.",
  "task.uploadError": "Ошибка загрузки",
  "task.finish": "Завершить",
  "task.atPointHint": "Нажмите, если вы на точке",
  "task.atPoint": "На точке",
  "error.title": "Ошибка",
  "error.ok": "Понятно",
  "country.choose": "Выбрать страну",
  "time.selected": "Вы выбрали:",
  "user.notInGroup": "не в группе",
  "search.players": "{count} игроков в игре",
  "search.none": "Игроков нет",
  "town.other": "Выберите другой город, если нужно",
  "town.inGame": "Вы находитесь в игре",
  "town.changeToEdit": "Смените город, чтобы изменить",
  "edit.nameRequired": "Введите ваше имя",
};

const en = {
  "lang.label": "Language",
  "nav.main": "Home",
  "nav.go": "Play",
  "nav.players": "Players",
  "nav.login": "Log in",
  "nav.menu": "Menu",
  "nav.navigation": "Navigation",
  "nav.welcome": "Welcome, {name}!",
  "nav.profile": "Profile",
  "nav.logout": "Log out",
  "nav.status": "Status",
  "nav.verified": "Verified",
  "nav.pending": "Pending",
  "country.prompt": "Select your country to continue",
  "country.kz": "Kazakhstan",
  "country.ru": "Russia",
  "login.title": "Log in",
  "login.haveAccount": "Already have an account?",
  "login.signIn": "Sign in",
  "login.noAccount": "No account?",
  "login.signUp": "Sign up",
  "login.email": "Email",
  "login.password": "Password",
  "login.submit": "Log in",
  "login.err.emailRequired": "Email is required",
  "login.err.email": "Email is invalid",
  "login.err.emailMax": "Email is too long",
  "login.err.passwordRequired": "Password is required",
  "login.err.capital": "Password must contain at least one capital letter",
  "login.err.digit": "Password must contain at least one number",
  "login.err.passwordMin": "Password must be at least 8 characters",
  "login.err.passwordMax": "Password must be at most 25 characters",
  "login.err.captcha": "Complete the captcha",
  "auth.invalid": "Email or password is incorrect",
  "auth.emailExist": "A user with this email already exists",
  "auth.notFound": "User not found",
  "auth.tooMany": "Too many sign-in attempts. Try again later",
  "register.title": "Sign up",
  "register.email": "Email",
  "register.password": "Password",
  "register.nickname": "Nickname",
  "register.birth": "Date of birth",
  "register.phone": "Phone number",
  "register.specialty": "Choose your specialty",
  "register.town": "Choose a city",
  "register.sex": "Choose your gender",
  "register.male": "Male",
  "register.female": "Female",
  "register.choose": "Choose...",
  "register.showAgreement": "Read the agreement",
  "register.hideAgreement": "Hide",
  "register.agreementTitle": "Agreement",
  "register.agreementIntro":
    "By checking the box you agree and confirm the following in order to use the app:",
  "register.agree": "Accept the agreement",
  "register.submit": "Sign up",
  "register.submitting": "Signing up...",
  "register.levelWait": "Player level is still loading. Wait and try again.",
  "register.fail": "Sign up failed",
  "register.a1": "You allow collection and processing of your data.",
  "register.a2": "You are an adult, or your parents are on your team.",
  "register.a3": "Your health allows sports and the loads of this game.",
  "register.a4":
    "If a player acts unlawfully, information may be given to the authorities.",
  "register.a5": "Swearing and obscene language are forbidden in videos.",
  "register.a6": "Advertising in videos is forbidden unless it is part of the task.",
  "register.a7": "Uploading unrelated videos instead of required ones blocks the account.",
  "register.a8":
    "A team with players under 16 must include two adults, one of them a parent of the minor.",
  "register.a9": "You have no medical reasons to avoid sports loads.",
  "register.a10": "Rights to videos uploaded to the app belong to the game administration.",
  "register.a11": "Sharing videos is allowed only with a link to the game.",
  "register.a12":
    "Each player is responsible for themselves and for a child if the team includes teenagers aged 16 or older.",
  "register.a13":
    "The administration may remove a team and its members for breaking the rules without explanation.",
  "register.a14":
    "The administration may restrict social accounts that use content against these rules.",
  "register.a15": "The contact details you gave are true and belong to you.",
  "register.a16": "Players must use strong passwords with symbols, letters, and digits.",
  "register.a17":
    "The administration may request extra data if parental rights are in doubt.",
  "register.a18":
    "Tasks require a lot of walking and solving unusual problems on camera.",
  "register.a19": "The team welcome video must show the faces of the participants.",
  "register.a20":
    "If player data does not match the video, the administration may act against the team.",
  "register.err.nickRequired": "Nickname is required",
  "register.err.nickChars": "Use only letters and digits",
  "register.err.nickMin": "Nickname must be at least 3 characters",
  "register.err.nickMax": "Up to 15 characters",
  "register.err.birth": "Date of birth is required",
  "register.err.phoneRequired": "Phone number is required",
  "register.err.phoneMin": "Phone number must be at least 10 digits",
  "register.err.phoneMax": "Phone number must be at most 15 digits",
  "register.err.specialty": "Choose your specialty",
  "register.err.license": "You cannot use the service without accepting the agreement",
  "register.err.town": "Choose a city",
  "main.teamName": "Unit name {name}",
  "main.createAndGo": "Create your team and go",
  "main.waitMembers": "Wait until your teammates confirm",
  "main.createTeam": "Create team",
  "main.addTeam": "Join a team",
  "main.dating": "Meetups",
  "main.verify": "Verify email",
  "footer.rights": "All rights reserved.",
  "footer.contact": "Contact",
  "common.close": "Close",
  "common.loading": "Loading...",
  "common.loadingTeam": "Loading team...",
  "common.city": "City:",
  "common.back": "Back",
  "common.send": "Send",
  "common.confirm": "Confirm",
  "common.cancel": "Cancel",
  "team.title": "Create team",
  "team.invited": "You have an invitation",
  "team.tryLater": "Please try again later",
  "team.info":
    "A team has 3 people. Fill in the fields carefully. Invite friends by INB (shown in the profile).",
  "team.infoLabel": "Info:",
  "team.name": "Team name:",
  "team.namePh": "Enter a team name",
  "team.member1": "First teammate:",
  "team.member2": "Second teammate:",
  "team.inbPh": "Invitee's INB",
  "team.invite": "Invite teammates",
  "team.sent": "Sent...",
  "team.inbHint": "Make sure your friends' INB is correct",
  "team.already": "{name} is already on a team!",
  "team.cannot": "You cannot create a new team while you are on one",
  "team.fail": "Could not create the team. Try again.",
  "team.err.nameRequired": "Name is required",
  "team.err.letters": "The name can contain only letters",
  "team.err.length": "3 to 32 characters",
  "team.err.exists": "This team name already exists",
  "team.err.tooLong": "Name is too long",
  "team.err.inbRequired": "Enter your teammate's INB",
  "team.err.noUser": "User does not exist",
  "team.err.inGroup": "User is already on a team",
  "team.err.invited": "User is already invited",
  "team.err.self": "You are inviting yourself",
  "team.err.repeat": "This invitation is repeated",
  "team.err.inbMax": "INB must be at most 25 characters",
  "team.err.town": "Choose a city",
  "random.info":
    "A team has up to 3 people. “Meetup” builds a pair of the opposite gender. If no pair is found, the team will have three random people.",
  "random.love": "Meetup",
  "random.members": "The team has {count} members",
  "random.two": "two",
  "random.three": "three",
  "random.age": "Opponents' age",
  "random.agePh": "Choose an age...",
  "random.place": "Meeting place",
  "random.placePh": "Choose a place...",
  "random.time": "Meeting time:",
  "random.identify": "How to recognize each other",
  "random.identifyPh": "How will you recognize each other?",
  "random.create": "Create team",
  "random.sent": "Sent...",
  "random.hint": "All fields are required",
  "random.noPlaces": "No meeting places yet",
  "random.tryLater": "Please try again later",
  "random.inTeam": "{name} is already on a team",
  "random.age1": "18 to 25",
  "random.age2": "26 to 35",
  "random.age3": "36 to 45",
  "random.age4": "46 to 60",
  "random.err.cafe": "Choose a meeting place",
  "random.err.time": "Choose a meeting time",
  "random.err.identify": "This field is required",
  "random.err.identifyMax": "Text is too long",
  "random.err.age": "Choose the opponents' age",
  "pay.title": "Payment",
  "pay.text":
    "Press “Send payment” to start the game. You do not need to pay. If a payment window opens, do not pay and contact support.",
  "pay.paid": "Paid:",
  "pay.sum": "Amount due",
  "pay.send": "Send payment",
  "pay.sending": "Sending...",
  "pay.fail": "Could not start the game. Try again.",
  "pay.noTeam": "Team not found. Create a team before starting the game.",
  "pay.started": "The game is already active.",
  "add.title": "Team invitation",
  "add.text": "If you agree, press Accept. Otherwise press Decline.",
  "add.accept": "Accept",
  "add.reject": "Decline",
  "add.none": "You have no invitations",
  "add.inGroup": "You are already on a team",
  "add.from": "Team invitation from",
  "meet.title": "Meeting place",
  "meet.cafe": "Cafe:",
  "meet.address": "Address:",
  "meet.datetime": "Date and time:",
  "meet.sign": "Recognition sign:",
  "meet.couple": "A man and a woman are playing",
  "meet.three": "3 people are playing",
  "meet.button": "We met",
  "meet.time": "time",
  "verify.prompt": "Enter the code sent to your email",
  "verify.button": "Verify email",
  "user.teamName": "Team name:",
  "user.loading": "Loading...",
  "user.noTeam": "Not on a team",
  "user.city": "City",
  "user.manage": "Team settings",
  "user.delete": "Delete team",
  "user.incomplete": "Team is incomplete",
  "user.waitOrDelete": "You can delete it or wait for confirmation",
  "user.disband": "Disband",
  "user.changeCity": "Change city",
  "user.change": "Change",
  "user.specialty": "Specialty",
  "user.level": "Level",
  "user.skills": "Skills:",
  "user.team": "Team:",
  "user.notFound": "No players found",
  "user.search": "Try changing the search",
  "user.name": "Name",
  "user.skillsCol": "Skills",
  "user.levelCol": "Level",
  "user.teamCol": "Team",
  "skills.title": "Skills:",
  "skills.empty": "We would like to see your skills",
  "go.timeUp": "Time is up",
  "go.anyOrder": "Complete the tasks in any order",
  "go.result": "Result",
  "go.hints": "Hints:",
  "go.h1": "If you are stuck, call a teammate",
  "go.h2": "A task may be in any language",
  "go.h3": "A task may involve carrying heavy items",
  "go.h4": "Every action needs a video, including the end of the task",
  "go.h5":
    "At a contact point, film the place, get the task, and record how you complete it",
  "go.h6":
    "Game videos belong to GO. Share them on social networks and YouTube only with a link to the site, or the account may be blocked",
  "go.h7": "The game scores the skills and achievements shown in your videos",
  "go.h8": "Film the game and enjoy it",
  "go.h9": "Read the tasks carefully",
  "go.h10":
    "The best content may be published on the game's YouTube channel. The main goal is the adrenaline and the smile",
  "job.notInGame": "Your team is not in the game",
  "job.onlyAtPoint": "The task is visible only at the given point",
  "job.l1":
    "Film the task. Each file must be under 36 MB, and you can upload up to three. One video is enough.",
  "job.l2": "Read the task carefully. That helps you win.",
  "job.l3": "Watch how you film. A bad video can affect the result.",
  "job.l4": "Use every possible way to solve the task.",
  "job.l5": "Enjoy the game.",
  "job.l6": "Videos are scored on many criteria.",
  "job.l7": "Use what your body can do to solve tasks and reach the goal.",
  "job.locationError": "Wrong location",
  "job.upload": "Upload video",
  "job.checkLocation": "Check your location and press the button again",
  "job.retry": "Try again",
  "job.return": "Go back",
  "job.title": "Job",
  "job.task": "Task",
  "complete.notDone": "The task is not finished. Upload a video and complete it",
  "complete.left": "Time left",
  "complete.hours": "hours",
  "invite.none": "No invitations",
  "confirm.title": "Confirmation",
  "confirm.text": "Are you sure you want to continue?",
  "play.inProgress": "in progress",
  "play.win": "win",
  "play.lose": "loss",
  "play.missions": "Missions",
  "play.secret": "Secret",
  "play.results": "Result",
  "loader.users": "Loading players...",
  "loader.missions": "Loading missions...",
  "loader.notPlayed": "You have not played yet",
  "loader.wait": "Waiting for a response...",
  "captcha.verify": "Verify captcha",
  "location.unsupported": "Your browser does not support geolocation",
  "location.disabled": "Geolocation is not enabled",
  "location.lat": "latitude",
  "location.lng": "longitude",
  "location.getting": "Getting the location…",
  "location.required": "This field is required",
  "location.invalid": "The value is invalid",
  "location.min": "At least 9 characters",
  "location.max": "At most 12 characters",
  "location.getTask": "Get task",
  "go.hello": "Hello, friend...",
  "go.cityBounds": "The task stays inside the city you chose.",
  "go.windows":
    "The windows hide missions. Open any window to start a task. Each task lasts 24 hours. When it is done, the next one begins.",
  "go.missionLeft": "Time left in the mission",
  "form.uploadLabel": "Upload a video (.mkv, .mov, .mp4, .avi)",
  "form.upload": "Upload",
  "form.checkQuality":
    "Check the file quality and upload it. These files prove that you completed the task. Good luck.",
  "form.reminder":
    "Every finished task is a video answer. When all files are uploaded, press Done.",
  "form.done": "Done",
  "form.lowercase": "The file name must be lowercase",
  "form.uploaded": "File uploaded: {name}",
  "task.info": "General information",
  "task.infoText":
    "If this is the first task of the mission, film your team, say the unit name, and the names or nicknames. Record the contact point, the task itself, and any other proof. No more than three files. Then move to the next task. A failed attempt is still scored, so upload your best clip. Content unrelated to the game can get the team removed.",
  "task.uploadError": "Upload error",
  "task.finish": "Finish",
  "task.atPointHint": "Press if you are at the point",
  "task.atPoint": "At the point",
  "error.title": "Error",
  "error.ok": "OK",
  "country.choose": "Choose a country",
  "time.selected": "You selected:",
  "user.notInGroup": "not in a team",
  "search.players": "{count} players in the game",
  "search.none": "No players",
  "town.other": "Choose another city if you need to",
  "town.inGame": "You are already in a game",
  "town.changeToEdit": "Change the city to edit it",
  "edit.nameRequired": "Enter your name",
};

const kk = {
  "lang.label": "Тіл",
  "nav.main": "Басты бет",
  "nav.go": "Ойын",
  "nav.players": "Ойыншылар",
  "nav.login": "Кіру",
  "nav.menu": "Мәзір",
  "nav.navigation": "Навигация",
  "nav.welcome": "Сәлеметсіз бе, {name}!",
  "nav.profile": "Профиль",
  "nav.logout": "Шығу",
  "nav.status": "Күйі",
  "nav.verified": "Расталған",
  "nav.pending": "Күтуде",
  "country.prompt": "Жалғастыру үшін елді таңдаңыз",
  "country.kz": "Қазақстан",
  "country.ru": "Ресей",
  "login.title": "Кіру",
  "login.haveAccount": "Аккаунтыңыз бар ма?",
  "login.signIn": "Кіру",
  "login.noAccount": "Аккаунт жоқ па?",
  "login.signUp": "Тіркелу",
  "login.email": "Электрондық пошта",
  "login.password": "Құпия сөз",
  "login.submit": "Кіру",
  "login.err.emailRequired": "Электрондық поштаны толтыру міндетті",
  "login.err.email": "Email қате енгізілген",
  "login.err.emailMax": "Email тым ұзын",
  "login.err.passwordRequired": "Құпия сөзді толтыру міндетті",
  "login.err.capital": "Құпия сөзде кемінде бір бас әріп болуы керек",
  "login.err.digit": "Құпия сөзде кемінде бір сан болуы керек",
  "login.err.passwordMin": "Құпия сөз кемінде 8 таңбадан тұруы керек",
  "login.err.passwordMax": "Құпия сөз 25 таңбадан аспауы керек",
  "login.err.captcha": "Капчаны өтіңіз",
  "auth.invalid": "Email немесе құпия сөз қате",
  "auth.emailExist": "Мұндай email бар пайдаланушы бар",
  "auth.notFound": "Пайдаланушы табылмады",
  "auth.tooMany": "Кіру әрекеті тым көп. Кейінірек көріңіз",
  "register.title": "Тіркелу",
  "register.email": "Электрондық пошта",
  "register.password": "Құпия сөз",
  "register.nickname": "Лақап ат",
  "register.birth": "Туған күні",
  "register.phone": "Телефон нөмірі",
  "register.specialty": "Мамандығыңызды таңдаңыз",
  "register.town": "Қаланы таңдаңыз",
  "register.sex": "Жынысыңызды таңдаңыз",
  "register.male": "Ер",
  "register.female": "Әйел",
  "register.choose": "Таңдау...",
  "register.showAgreement": "Келісіммен танысу",
  "register.hideAgreement": "Жасыру",
  "register.agreementTitle": "Келісім",
  "register.agreementIntro":
    "Қолданбаны пайдалану үшін құсбелгіні қойып, мыналарға келісесіз және растайсыз:",
  "register.agree": "Келісімді растау",
  "register.submit": "Тіркелу",
  "register.submitting": "Тіркелуде...",
  "register.levelWait": "Ойыншы деңгейі әлі жүктелмеді. Күтіп, қайта көріңіз.",
  "register.fail": "Тіркелу сәтсіз аяқталды",
  "register.a1": "Деректерді жинауға және өңдеуге рұқсат бересіз.",
  "register.a2": "Сіз кәмелетке толғансыз немесе командаңызда ата-анаңыз бар.",
  "register.a3": "Денсаулығыңыз спортпен айналысуға және ойын жүктемесіне жарайды.",
  "register.a4":
    "Ойыншы заңсыз әрекет етсе, ақпарат құқық қорғау органдарына берілуі мүмкін.",
  "register.a5": "Бейнелерде боқтау мен былапыт сөзге тыйым салынады.",
  "register.a6": "Тапсырманың бөлігі болмаса, бейнеде жарнамаға тыйым салынады.",
  "register.a7": "Қажетті бейненің орнына бөгде бейне жүктеу аккаунтты бұғаттайды.",
  "register.a8":
    "16 жасқа толмаған жасөспірім бар командада екі ересек болуы керек, біреуі — ата-анасы.",
  "register.a9": "Спорттық жүктемеге қарсы көрсетіліміңіз жоқ.",
  "register.a10":
    "Қолданбаға жүктелген бейнелердің құқығы ойын әкімшілігіне тиесілі.",
  "register.a11": "Бейнені тек ойын сілтемесімен бөлісуге болады.",
  "register.a12":
    "Әр қатысушы өзіне және командада 16 жастан асқан жасөспірім болса, балаға жауапты.",
  "register.a13":
    "Ереже бұзылса, әкімшілік себебін түсіндірмей команданы және қатысушыларды жоя алады.",
  "register.a14":
    "Ережеге қайшы контент қолданған әлеуметтік аккаунттарды әкімшілік шектей алады.",
  "register.a15": "Көрсетілген байланыс деректері шын және сізге тиесілі.",
  "register.a16": "Қатысушылар таңба, әріп және сан бар мықты құпия сөз қолданады.",
  "register.a17":
    "Ата-ана құқығына күмән болса, әкімшілік қосымша дерек сұрай алады.",
  "register.a18":
    "Тапсырма үшін көп жүру және камерада стандарттан тыс есеп шығару керек.",
  "register.a19": "Команданың сәлемдесу бейнесінде қатысушылардың жүзі көрінуі керек.",
  "register.a20":
    "Ойыншы деректері мен бейне сәйкес келмесе, әкімшілік командаға шара қолдана алады.",
  "register.err.nickRequired": "Лақап атты толтыру міндетті",
  "register.err.nickChars": "Тек әріп пен сан болуы керек",
  "register.err.nickMin": "Лақап ат кемінде 3 таңбадан тұруы керек",
  "register.err.nickMax": "15 таңбаға дейін",
  "register.err.birth": "Туған күн көрсетілмеген",
  "register.err.phoneRequired": "Телефон нөмірін толтыру міндетті",
  "register.err.phoneMin": "Телефон нөмірі кемінде 10 саннан тұруы керек",
  "register.err.phoneMax": "Телефон нөмірі 15 саннан аспауы керек",
  "register.err.specialty": "Мамандықты таңдау міндетті",
  "register.err.license": "Келісімді растамай сервисді пайдалана алмайсыз",
  "register.err.town": "Қала таңдалмаған",
  "main.teamName": "Бөлімше атауы {name}",
  "main.createAndGo": "Команда құрып, алға",
  "main.waitMembers": "Топ мүшелерінің растауын күт",
  "main.createTeam": "Команда құру",
  "main.addTeam": "Командаға қосылу",
  "main.dating": "Танысу",
  "main.verify": "Поштаны растау",
  "footer.rights": "Барлық құқықтар қорғалған.",
  "footer.contact": "Байланыс",
  "common.close": "Жабу",
  "common.loading": "Жүктелуде...",
  "common.loadingTeam": "Команда жүктелуде...",
  "common.city": "Қала:",
  "common.back": "Артқа",
  "common.send": "Жіберу",
  "common.confirm": "Растау",
  "common.cancel": "Болдырмау",
  "team.title": "Команда құру",
  "team.invited": "Сізде шақыру бар",
  "team.tryLater": "Кейінірек қайта көріңіз",
  "team.info":
    "Команда 3 адамнан тұрады. Өрістерді мұқият толтырыңыз. Достарыңызды профильдегі INB бойынша шақырыңыз.",
  "team.infoLabel": "Ақпарат:",
  "team.name": "Команда атауы:",
  "team.namePh": "Топ атауын енгізіңіз",
  "team.member1": "Бірінші қатысушы:",
  "team.member2": "Екінші қатысушы:",
  "team.inbPh": "Шақырылған адамның INB",
  "team.invite": "Қатысушыларды шақыру",
  "team.sent": "Жіберілді...",
  "team.inbHint": "Достарыңыздың INB дұрыс екеніне көз жеткізіңіз",
  "team.already": "{name} командада!",
  "team.cannot": "Қазіргі командада тұрғанда жаңасын құра алмайсыз",
  "team.fail": "Команда құрылмады. Қайта көріңіз.",
  "team.err.nameRequired": "Атауды толтыру міндетті",
  "team.err.letters": "Атауда тек әріп болуы керек",
  "team.err.length": "3–32 таңба",
  "team.err.exists": "Мұндай топ атауы бар",
  "team.err.tooLong": "Атау тым ұзын",
  "team.err.inbRequired": "Серіктестің INB енгізіңіз",
  "team.err.noUser": "Пайдаланушы жоқ",
  "team.err.inGroup": "Пайдаланушы топта бар",
  "team.err.invited": "Пайдаланушы шақырылған",
  "team.err.self": "Өзіңізді шақырып жатырсыз",
  "team.err.repeat": "Шақыру қайталанады",
  "team.err.inbMax": "INB 25 таңбадан аспауы керек",
  "team.err.town": "Қала таңдалмаған",
  "random.info":
    "Команда 3 адамға дейін. «Танысу» қарама-қарсы жыныстан жұп құрайды. Жұп болмаса, үш кездейсоқ адамнан команда құрылады.",
  "random.love": "Танысу",
  "random.members": "Команда {count} қатысушыдан тұрады",
  "random.two": "екі",
  "random.three": "үш",
  "random.age": "Қарсыластардың жасы",
  "random.agePh": "Жасты таңдаңыз...",
  "random.place": "Кездесу орны",
  "random.placePh": "Орынды таңдаңыз...",
  "random.time": "Кездесу уақыты:",
  "random.identify": "Бір-бірін қалай тану",
  "random.identifyPh": "Бір-біріңізді қалай танисыз?",
  "random.create": "Команда құру",
  "random.sent": "Жіберілді...",
  "random.hint": "Барлық өріс міндетті",
  "random.noPlaces": "Кездесу орындары көрсетілмеген",
  "random.tryLater": "Кейінірек қайта көріңіз",
  "random.inTeam": "{name} командада",
  "random.age1": "18-ден 25 жасқа дейін",
  "random.age2": "26-дан 35 жасқа дейін",
  "random.age3": "36-дан 45 жасқа дейін",
  "random.age4": "46-дан 60 жасқа дейін",
  "random.err.cafe": "Кездесу орнын таңдаңыз",
  "random.err.time": "Кездесу уақытын таңдаңыз",
  "random.err.identify": "Толтыру қажет",
  "random.err.identifyMax": "Мәтін тым ұзын",
  "random.err.age": "Қарсыластардың жасын таңдаңыз",
  "pay.title": "Төлем терезесі",
  "pay.text":
    "Ойынды іске қосу үшін «Төлемді жіберу» түймесін басыңыз. Төлеудің қажеті жоқ. Төлем терезесі ашылса, төлемеңіз және қолдауға жазыңыз.",
  "pay.paid": "Төленді:",
  "pay.sum": "Төленетін сома",
  "pay.send": "Төлемді жіберу",
  "pay.sending": "Жіберілуде...",
  "pay.fail": "Ойын іске қосылмады. Қайта көріңіз.",
  "pay.noTeam": "Команда табылмады. Ойынды қоспас бұрын команда құрыңыз.",
  "pay.started": "Ойын қосылып қойған.",
  "add.title": "Командаға шақыру",
  "add.text": "Келіссеңіз «Қабылдау», болмаса «Бас тарту» түймесін басыңыз.",
  "add.accept": "Қабылдау",
  "add.reject": "Бас тарту",
  "add.none": "Шақыруыңыз жоқ",
  "add.inGroup": "Сіз топтасыз",
  "add.from": "Командаға шақыру:",
  "meet.title": "Кездесу орны",
  "meet.cafe": "Кафе:",
  "meet.address": "Мекенжай:",
  "meet.datetime": "Күні мен уақыты:",
  "meet.sign": "Тану белгісі:",
  "meet.couple": "Ойында жігіт пен қыз",
  "meet.three": "Ойында 3 адам",
  "meet.button": "Кездестік",
  "meet.time": "уақыт",
  "verify.prompt": "Поштаға жіберілген кодты енгізіңіз",
  "verify.button": "Поштаны растау",
  "user.teamName": "Команда атауы:",
  "user.loading": "Жүктелуде...",
  "user.noTeam": "Командада жоқ",
  "user.city": "Қала",
  "user.manage": "Топты басқару",
  "user.delete": "Топты жою",
  "user.incomplete": "Топ толық емес",
  "user.waitOrDelete": "Жоюға немесе растауды күтуге болады",
  "user.disband": "Тарату",
  "user.changeCity": "Қаланы өзгерту",
  "user.change": "Өзгерту",
  "user.specialty": "Мамандық",
  "user.level": "Деңгей",
  "user.skills": "Дағдылар:",
  "user.team": "Команда:",
  "user.notFound": "Ойыншылар табылмады",
  "user.search": "Іздеу параметрлерін өзгертіп көріңіз",
  "user.name": "Аты",
  "user.skillsCol": "Дағдылар",
  "user.levelCol": "Деңгей",
  "user.teamCol": "Команда",
  "skills.title": "Дағдылар:",
  "skills.empty": "Қабілеттеріңізді көргіміз келеді",
  "go.timeUp": "Уақыт бітті",
  "go.anyOrder": "Тапсырмаларды кез келген ретпен орында",
  "go.result": "Нәтиже",
  "go.hints": "Кеңестер:",
  "go.h1": "Тапсырма тығырыққа тіресе, серіктесіңді шақыр",
  "go.h2": "Тапсырма әлемнің кез келген тілінде болуы мүмкін",
  "go.h3": "Тапсырма ауыр жүк тасуды қажет етуі мүмкін",
  "go.h4": "Әр әрекетке, соның ішінде аяқталуына, бейне керек",
  "go.h5":
    "Байланыс нүктесінде орынды түсіріп, тапсырманы алыңыз және орындауын жазыңыз",
  "go.h6":
    "Ойын бейнелері GO-ға тиесілі. Әлеуметтік желі мен YouTube-қа тек сайт сілтемесімен салыңыз, әйтпесе аккаунт бұғатталуы мүмкін",
  "go.h7": "Ойында бейнеде көрінген қабілет пен жетістік бағаланады",
  "go.h8": "Ойын барысын түсіріп, рахаттан",
  "go.h9": "Тапсырмаларды мұқият оқыңыз",
  "go.h10":
    "Ең үздік контент ойынның YouTube арнасында жариялануы мүмкін. Бастысы — адреналин мен жымию",
  "job.notInGame": "Командаңыз ойында емес",
  "job.onlyAtPoint": "Тапсырма тек берілген нүктеде көрінеді",
  "job.l1":
    "Тапсырманы камераға түсіріңіз. Файл 36 МБ-тан аспауы керек, үшеуге дейін жүктей аласыз. Бір бейне жеткілікті.",
  "job.l2": "Тапсырманы мұқият оқыңыз — бұл жеңіске көмектеседі.",
  "job.l3": "Бейне шолуды қадағалаңыз. Қате түсірілім нәтижеге әсер етуі мүмкін.",
  "job.l4": "Шешудің барлық мүмкін жолын қолданыңыз.",
  "job.l5": "Ойында рахаттаныңыз.",
  "job.l6": "Бейне көп параметр бойынша бағаланады.",
  "job.l7": "Міндетті шешу үшін ағзаңыздың мүмкіндігін пайдаланыңыз.",
  "job.locationError": "Орын қате",
  "job.upload": "Бейне жүктеу",
  "job.checkLocation": "Орынды тексеріп, түймені қайта басыңыз",
  "job.retry": "Қайталау",
  "job.return": "Оралу",
  "job.title": "Тапсырма",
  "job.task": "Міндет",
  "complete.notDone": "Тапсырма аяқталмаған: бейне жүктеп, оны аяқтаңыз",
  "complete.left": "Тапсырманың аяқталуына",
  "complete.hours": "сағат",
  "invite.none": "Шақыру жоқ",
  "confirm.title": "Растау",
  "confirm.text": "Жалғастырғыңыз келетініне сенімдісіз бе?",
  "play.inProgress": "орындалуда",
  "play.win": "жеңіс",
  "play.lose": "жеңіліс",
  "play.missions": "Миссиялар",
  "play.secret": "Құпия",
  "play.results": "Нәтиже",
  "loader.users": "Ойыншылар жүктелуде...",
  "loader.missions": "Миссиялар жүктелуде...",
  "loader.notPlayed": "Сіз әлі ойнаған жоқсыз",
  "loader.wait": "Жауап күтіңіз...",
  "captcha.verify": "Капчаны тексеру",
  "location.unsupported": "Браузер геолокацияны қолдамайды",
  "location.disabled": "Геолокация өшірулі",
  "location.lat": "ендік",
  "location.lng": "бойлық",
  "location.getting": "Координат алынуда…",
  "location.required": "Толтыру міндетті",
  "location.invalid": "Дерек қате енгізілген",
  "location.min": "Кемінде 9 таңба",
  "location.max": "Ең көбі 12 таңба",
  "location.getTask": "Тапсырма алу",
  "go.hello": "Сәлем, досым...",
  "go.cityBounds": "Тапсырма таңдалған қала шегінде орындалады.",
  "go.windows":
    "Алдыңызда миссиялар жасырылған терезелер. Кез келгенін ашып, тапсырманы бастайсыз. Әр тапсырмаға 24 сағат беріледі. Аяқтаған соң келесісі басталады.",
  "go.missionLeft": "Миссияның аяқталуына",
  "form.uploadLabel": "Бейне жүктеңіз (.mkv, .mov, .mp4, .avi)",
  "form.upload": "Жүктеу",
  "form.checkQuality":
    "Файл сапасын тексеріп, жүктеңіз. Бұл файлдар тапсырманы орындағаныңызды растайды. Сәттілік.",
  "form.reminder":
    "Әр орындалған тапсырма — бейнежауап. Барлық файл жүктелгенде «Орындалды» түймесін басыңыз.",
  "form.done": "Орындалды",
  "form.lowercase": "Файл атауы кіші әріппен болуы керек",
  "form.uploaded": "Файл жүктелді: {name}",
  "task.info": "Жалпы ақпарат",
  "task.infoText":
    "Миссияның алғашқы тапсырмасы болса, команда шолуын түсіріп, бөлімше атауы мен аттарды немесе лақап аттарды айтыңыз. Байланыс нүктесін, тапсырманы орындауды және басқа дәлелдерді жазыңыз. Үш файлдан артық емес. Содан кейін келесі тапсырмаға өтіңіз. Сәтсіз әрекет те бағаланады — ең жақсы ролик жүктеңіз. Ойынға қатысы жоқ контент үшін команда жойылуы мүмкін.",
  "task.uploadError": "Жүктеу қатесі",
  "task.finish": "Аяқтау",
  "task.atPointHint": "Нүктеде болсаңыз, басыңыз",
  "task.atPoint": "Нүктеде",
  "error.title": "Қате",
  "error.ok": "Түсінікті",
  "country.choose": "Елді таңдау",
  "time.selected": "Сіз таңдадыңыз:",
  "user.notInGroup": "командада жоқ",
  "search.players": "ойында {count} ойыншы",
  "search.none": "Ойыншы жоқ",
  "town.other": "Қажет болса, басқа қала таңдаңыз",
  "town.inGame": "Сіз ойындасыз",
  "town.changeToEdit": "Өзгерту үшін қаланы ауыстырыңыз",
  "edit.nameRequired": "Атыңызды енгізіңіз",
};

export const translations = { ru, en, kk };

export function translate(language, key, params) {
  const table = translations[language] || translations.ru;
  let text = table[key] ?? translations.ru[key] ?? key;
  if (params) {
    Object.entries(params).forEach(([name, value]) => {
      text = text.replaceAll(`{${name}}`, value ?? "");
    });
  }
  return text;
}
